// extracted by mini-css-extract-plugin
export default {"latestActivity":"CdFVS","activities":"HypwC","activity":"Ld7mq","allActivities":"o8jwP"};